import { render, staticRenderFns } from "./sbSelezioneSorgente.vue?vue&type=template&id=a995702e"
import script from "./sbSelezioneSorgente.vue?vue&type=script&lang=js"
export * from "./sbSelezioneSorgente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports